<template>
  <div>
    <el-table
      :data="blogList"
      stripe
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column width="200" label="标签">
        <template slot-scope="scope">
          <div class="react topping" v-if="scope.row.topping == true" style="float:left;">置顶</div>

          <div class="react essence" v-if="scope.row.essence == true" style="float:left;">精华</div>
          <div v-for="item in scope.row.tags" :key="item.id">
            <el-tooltip class="item" effect="dark" :content="item.tag_name" placement="top">
              <div class="circular" :style="getColorStyle(item.tag_col)"></div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="170" label="创建时间" align="center">
        <template slot-scope="scope">
          {{changeTimeDate(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">

        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleShow(scope.$index, scope.row)"
          >查看</el-button>

<!--          <el-button-->
<!--            type="text"-->
<!--            icon="el-icon-delete"-->
<!--            class="red"-->
<!--            @click="handleDelete(scope.$index, scope.row)"-->
<!--          >删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {getBlogList} from '../../../../../request/api'
import Utils from '../../../../../js/Utils'
// import Common from '../../../../../js/Common'

export default {
  name: 'BackBlogManage',
  data () {
    return {
      blogList: []
    }
  },
  created () {
    this.getData()
  },
  methods: {

    getData () {
      getBlogList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.blogList = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    },
    getColorStyle (color) {
      return 'background-color:' + color
    },
    changeTimeDate (date) {
      return Utils.formatDate(date.create_blog_time)
    },
    handleShow (index, row) {
      this.$router.push({path: '/back/blog_info', name: 'BackBlogInfo', query: {blog_id: row.id}})
    }

  }
}
</script>

<style scoped>
.topping{
  background: dodgerblue;
}
.essence{
  background: red;
}
/*.react {*/
/*  width: 25px;*/
/*  height: 32px;*/
/*  margin-right: 5px;*/
/*  text-align: center;*/
/*  transform: skewX(-20deg);*/
/*  margin-top: 4px;*/
/*}*/

.react {
  width: 44px;
  height: 22.5px;
  padding: 1px 10px;
  margin-right: 5px;
  text-align: center;
  /*transform: skewX(-20deg);*/
  margin-top: 8.5px;

  font-size: 12px;
  border-radius: 5px;
  color: white;
}
.circular{
  border-radius: 12px;
  border:1px solid white;
  width: 22px;
  height: 22px;
  float: right;
  margin-right: -10px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/back/blog/BackBlogManage.vue